// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__122NR","content":"styles_content__1UANN"};